import { ErrorResponseInterface } from "interfaces/common.interface";


export const transformErrorResponse = (
  response:
    | any
    | {
        state?: number;
        redirects?: any;
        data?: any;
        message?: string;
        errors?: any;
      }
  ) => {
    // Assuming state 0 means error, state 1 means success
    if (response.state === 0) {
      const errorResponse: ErrorResponseInterface = {
        state: response.state,
        message: response.message || 'Unknown error',
        errors: response.errors || null,
        redirects: response.redirects || null,
        data: response.data || null,
      };
      return errorResponse;
    }
    return response;
};
